import type {
  GoogleLoginRequest,
  LoginRequest,
  PlayerAuthResponse,
  RegisterRequest,
} from '@/entities/session/types';
import { requestJson } from '@/shared/request/http-client';

export const loginPlayer = (payload: LoginRequest) =>
  requestJson<PlayerAuthResponse, LoginRequest>('/v1/app/auth/login', {
    body: payload,
    method: 'POST',
  });

export const registerPlayer = (payload: RegisterRequest) =>
  requestJson<PlayerAuthResponse, RegisterRequest>('/v1/app/auth/register', {
    body: payload,
    method: 'POST',
  });

/** 美国站 loginOptions：发送登录短信 */
export const sendLoginSms = (payload: { phone: string; siteId: string }) =>
  requestJson<void, { phone: string; siteId: string }>('/v1/app/auth/sms/send', {
    body: payload,
    method: 'POST',
  });

/** 美国站 loginOptions：手机号 + 短信验证码登录（新号自动注册） */
export const loginPlayerBySms = (payload: {
  agentCode?: string;
  code: string;
  phone: string;
  referralCode?: string;
  registerHost?: string;
  siteId: string;
}) =>
  requestJson<PlayerAuthResponse, typeof payload>('/v1/app/auth/sms/login', {
    body: payload,
    method: 'POST',
  });

/** 美国站 Guest：服务端创建游客并签发会话 */
export const loginPlayerAsGuest = (payload: {
  agentCode?: string;
  referralCode?: string;
  registerHost?: string;
  siteId: string;
}) =>
  requestJson<
    PlayerAuthResponse,
    { agentCode?: string; referralCode?: string; registerHost?: string; siteId: string }
  >('/v1/app/auth/guest', {
    body: payload,
    method: 'POST',
  });

/** Google Identity Services：提交 id_token，服务端验签后签发会话 */
export const loginPlayerByGoogle = (payload: GoogleLoginRequest) =>
  requestJson<PlayerAuthResponse, GoogleLoginRequest>('/v1/app/auth/google', {
    body: payload,
    method: 'POST',
  });
